module.exports = __webpack_public_path__ + "static/media/Stephenson.250a6c1b.png";